export default __webpack_public_path__ + "d482592d7c174e420a17c89408233fcf.png";